import * as React from 'react';

import styles from './DocumentMessageLayout.css';
import { EMessageType } from '../../../../types/messageType';
import { EUserColor } from '../../../../types/userName';
import { ChatMessageBubble } from '../../../ChatMessageBubble';
import { ChatMessageRow } from '../../../ChatMessageRow';
import { MetaRow } from '../MetaRow';

interface IDocumentMessageLayoutProps {
  errorSign: React.ReactNode;
  errorText: React.ReactNode;
  messageType: EMessageType;
  isLastMessageInChain: boolean;
  documentMessage: React.ReactNode;
  messageMeta: React.ReactNode;
  userColor?: EUserColor;
}

export const DocumentMessageLayout = React.forwardRef<HTMLDivElement, IDocumentMessageLayoutProps>(
  function DocumentMessageLayout(
    { errorSign, errorText, messageType, isLastMessageInChain, documentMessage, messageMeta, userColor },
    ref,
  ) {
    return (
      <ChatMessageRow errorSign={errorSign} errorText={errorText}>
        <ChatMessageBubble
          messageType={messageType}
          withTail={isLastMessageInChain}
          className={styles['document-message__bubble']}
          ref={ref}
          userColor={userColor}
        >
          {documentMessage}
          <MetaRow messageType={messageType} userColor={userColor}>
            {messageMeta}
          </MetaRow>
        </ChatMessageBubble>
      </ChatMessageRow>
    );
  },
);
